/**
 * SetupGate — wraps the entire app. On mount, polls /api/setup/status:
 *   - If setup_required === true → render <SetupWizard/> only.
 *   - If false → render children normally.
 *
 * Failure cases (network error / 5xx) → render children so the existing
 * AI Tutor — Health Analytics deployment never gets stuck behind the gate.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SetupWizard from '../pages/SetupWizard';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SetupGate = ({ children }) => {
  const [state, setState] = useState({ checking: true, setupRequired: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/api/setup/status`);
        if (cancelled) return;
        setState({ checking: false, setupRequired: !!res.data?.setup_required });
      } catch (_err) {
        if (cancelled) return;
        // Fail open: don't strand existing deployments behind a wizard if
        // the endpoint can't be reached for any reason.
        setState({ checking: false, setupRequired: false });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.checking) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50" data-testid="setup-gate-loading">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-10 w-10 border-t-2 border-b-2" style={{ borderColor: 'var(--unthsc-green, #00853E)' }} />
          <p className="mt-3 text-gray-600">Loading…</p>
        </div>
      </div>
    );
  }

  if (state.setupRequired) {
    return <SetupWizard />;
  }

  return children;
};

export default SetupGate;
